import { useAppDispatch, useTheme, IconButton, Icon } from '../../base';
import {} from // ResetPasswordGrid, // Removed unused import
'./ResetPasswordPage.styles';
import { loginActions } from '../../actions';
import { useLocation, useNavigate } from 'react-router-dom';
import ResetPasswordForm from '../../components/ResetPasswordForm/ResetPasswordForm';
import { LoginCardLayout, MobileLoginLayout } from '../../components';
import { useMediaQuery as useMuiMediaQuery } from '@mui/material';
import { RoutePaths } from '../../routes/RoutePaths'; // Added RoutePaths

const ResetPasswordPage = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const theme = useTheme();
    const isMobile = useMuiMediaQuery(theme.breakpoints.down('md'));
    const navigate = useNavigate(); // Added

    const uid = queryParams.get('uid') || '';
    const token = queryParams.get('token') || '';

    const onResetPasswordSubmit = (payload: { new_password: string }) => {
        const sagaPayload = {
            uid,
            token,
            ...payload,
        };
        dispatch(loginActions.fetchResetPassword(sagaPayload));
    };

    const LayoutComponent = isMobile ? MobileLoginLayout : LoginCardLayout;

    return (
        <LayoutComponent>
            {/* Added Back Button for Mobile */}
            {isMobile && (
                <IconButton
                    onClick={() => navigate(RoutePaths.login)}
                    sx={{
                        position: 'absolute',
                        top: theme.spacing(2),
                        insetInlineStart: theme.spacing(2),
                        zIndex: 10,
                        color: 'white',
                        backgroundColor: theme.palette.secondary.main,
                        '&:hover': {
                            backgroundColor: theme.palette.secondary.dark,
                        },
                    }}
                >
                    <Icon name="BackIcon" />
                </IconButton>
            )}
            <ResetPasswordForm
                onSubmit={onResetPasswordSubmit}
                isMobile={isMobile}
            />
        </LayoutComponent>
    );
};

export default ResetPasswordPage;
